import { useEffect, useState } from 'react';
import { detectTheme, getTheme } from 'Utilities/themeHelpers';
const useTheme = () => {
  const [theme, setTheme] = useState(getTheme(new URLSearchParams(window.location.search)));
  useEffect(() => {
    const matchMedia = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      const urlParams = new URLSearchParams(window.location.search);
      setTheme(detectTheme(urlParams));
    };
    matchMedia.addEventListener('change', handleChange);
    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, []);
  return {
    theme
  };
};
export default useTheme;